.huge {
  font-size: 36px;
}

.extraLarge {
  font-size: 25px;
}

.midLarge {
  font-size: 20px;
}

.large {
  font-size: 18px;
}

.medium {
  font-size: 16px;
}

.extraSmall {
  font-size: 12px;
}

.midSmall {
  font-size: 11px;
}

.extraExtraSmall {
  font-size: 10px;
}

.small {
  font-size: 14px;
}

.extraBold {
  font-weight: 700;
}

.midBold {
  font-weight: 600;
}

.bold {
  font-weight: 500;
}

.normal {
  font-weight: 400;
}

.thin {
  font-weight: 100;
}

.standard,
.primary {
  @include themify($themes) {
    color: themed("main-primary");
  }
}

.standard.secondary {
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.error {
  @include themify($themes) {
    color: themed("error-primary");
  }
}
